<template>
  <div class="img-list-page">
    <div class="list-item" v-for="item in list" :key="item.id">
      <div class="item-image">
        <img :src="item.image" :alt="item.title" />
      </div>
      <div class="item-content">
        <h3 class="item-title">{{ item.title }}</h3>
        <p class="item-desc">{{ item.description }}</p>
        <div class="item-date">
          <i class="icon-clock"></i>
          <span>{{ item.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgListPage',
  data() {
    return {
      list: [
        {
          id: 1,
          image: 'https://picsum.photos/245/150?random=1',
          title: '山东省心理咨询行业协会第二届第一次会员代表大会暨换届选举大会成功召开',
          description: '10月30日，山东省心理咨询行业协会第二届第一次会员代表大会暨换届选举大会在济宁医学院太白湖校区顺利召开。学校党委书记卢国华、山东省心理卫生协会会长易雄湖出席开幕式并致辞。党委委员、副院长、协...',
          date: '2025-11-01'
        },
        {
          id: 2,
          image: 'https://picsum.photos/245/150?random=2',
          title: '山东省心理咨询行业协会第2期"心理测量"技能培训班顺利结业',
          description: '由山东省心理咨询行业协会主办，济宁医学院精神卫生学院承办的第2期&ldquo;心理测量&rdquo;技能培训班于2024年6月21-23日在济宁医学院（任城校区）如期举办并顺利结业。共计35名学员参加培训并获得了心...',
          date: '2024-06-25'
        },
        {
          id: 3,
          image: 'https://picsum.photos/245/150?random=3',
          title: '山东省心理咨询行业协会成立大会胜利召开',
          description: '为更好地促进全省心理咨询行业的健康与持续发展，在山东省民政厅社会组织管理局监督下，由济宁医学院牵头，与山东省立医院、山东第一医科大学、山东中医药大学、山东省精神卫生中心、济宁市精神病防治...',
          date: '2019-07-16'
        }
      ]
    }
  },
  created() {
    // 初始化数据
    this.fetchList()
  },
  methods: {
    fetchList() {
      // 模拟异步获取数据
      // 实际项目中可以调用 API 接口
      console.log('列表数据已加载', this.list)
    }
  }
}
</script>

<style scoped>
.img-list-page {
  padding: 20px;
}

.list-item {
  display: flex;
  background: #fff;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: relative;
}

.list-item:hover {
  transform: translateX(8px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.item-image {
  flex-shrink: 0;
  width: 245px;
  height: 150px;
  margin-right: 20px;
  overflow: hidden;
  border-radius: 4px;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.list-item:hover .item-title {
  color: #1890ff;
}

.item-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #999;
}

.icon-clock {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23999"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"/></svg>') no-repeat center;
  background-size: contain;
}
</style>
